document.addEventListener('DOMContentLoaded', function() {
  function animateWrapperFunction() {
    if (!window?.gsap || !window?.ScrollTrigger) return;

    function isAnimationDisabled(el) {
      if (!el || typeof el.closest !== 'function') return false;
      if (el.closest('[data-disable-animation="true"]')) return true;
      if (el.closest('.section-feature-product-list')) return true;
      return false;
    }

    function getResponsiveDuration(desktopDuration) {
        // Decrease by 20% on mobile (< 990px)
        if (window.innerWidth < 990) {
            return desktopDuration * 0.8;
        }
        return desktopDuration;
    }
    // Trending Offer
    document.querySelectorAll('.section-trending-offers').forEach(function(section) {
      if (isAnimationDisabled(section)) return;
      gsap.fromTo(section,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: getResponsiveDuration(1),
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 95%",
            toggleActions: "play none none none",
            once: true, 
            onEnter: () => {
              // Animate the 2nd offer item with a delay after section animates in
              const secondItem = section.querySelector('.trending-offers__grid .trending-offer__item:nth-child(2)');
              const fourthItem = section.querySelector('.trending-offers__grid .trending-offer__item:nth-child(4)');
              if (secondItem) {
                gsap.fromTo(secondItem,
                  { opacity: 0, y: 60 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: getResponsiveDuration(1),
                    delay: 0.4, // delay after section animation starts
                    ease: "power2.out"
                  }
                );
              }
              if(fourthItem) {
                gsap.fromTo(fourthItem,
                  { opacity: 0, y: 60 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: getResponsiveDuration(1),
                    delay: 0.4,
                    ease: "power2.out"
                  }
                );
              }
            }
          }
        }
      );
    });

    const animateObjectFromBottomToTop = (section) => {
        return {
            opacity: 1,
            y: 0,
            duration: getResponsiveDuration(1.5),
            ease: "power2.out",
            scrollTrigger: {
                trigger: section,
                start: "top 95%", // when top of section hits 90% of viewport
                toggleActions: "play none none none"
            }
        }
    }

    // Sale Banner Block
    document.querySelectorAll('.section-sales-banner-block.ui-sales-banner-block').forEach(function(section) {
      if (isAnimationDisabled(section)) return;
      gsap.fromTo(section,
        { opacity: 0, y: 100 },
        { ...animateObjectFromBottomToTop(section) }
      );
    });
          

   document.querySelectorAll('.newsletter').forEach(function(section) {
     if (isAnimationDisabled(section)) return;
     gsap.fromTo(section,
       { opacity: 0, y: 100 },
       { ...animateObjectFromBottomToTop(section) }
     );
   });

   document.querySelectorAll('.shopify-section-group-footer-group.section-wrapper').forEach(function(section) {
     if (isAnimationDisabled(section)) return;
     gsap.fromTo(section,
       { opacity: 0, y: 100 },
       { ...animateObjectFromBottomToTop(section) }
     );
   });

   document.querySelectorAll('.popular-brands__items').forEach(function(items) {
      if (isAnimationDisabled(items)) return;
      gsap.fromTo(items,
        { opacity: 0, x: 100 },
        {
          opacity: 1,
          x: 0,
          duration: getResponsiveDuration(1),
          ease: "power2.out",
          scrollTrigger: {
            trigger: items,
            start: "top 95%",
            toggleActions: "play none none none",
            once: true
          }
        }
      );
    });

    document.querySelectorAll('.feature-brand__video video').forEach(function(videoEl) {
      if (isAnimationDisabled(videoEl)) return;
      gsap.fromTo(videoEl,
        { scale: 1 },
        {
          scale: 1.08,
          duration: getResponsiveDuration(3),
          ease: "power2.out",
          scrollTrigger: {
            trigger: videoEl,
            start: "top 95%",
            toggleActions: "play reverse play reverse",
            once: true,
            onComplete: () => {
              gsap.to(videoEl, {
                scale: 1,
                duration: getResponsiveDuration(4),
                ease: "power2.out"
              });
            }
          }
        }
      );
    });

    document.querySelectorAll('.feature-articles__container').forEach(function(container) {
        if (isAnimationDisabled(container)) return;
        const articleItems = container.querySelectorAll('.article-item');
        if (articleItems.length > 0) {
            // Animate the first article as before
            const firstArticle = articleItems[0];
            const image = firstArticle?.querySelector('.article-item__image');
            const content = firstArticle?.querySelector('.article-item__content');
            if (image) {
            gsap.fromTo(image,
                { opacity: 0 },
                {
                opacity: 1,
                duration: getResponsiveDuration(1),
                ease: "power2.out",
                scrollTrigger: {
                    trigger: firstArticle,
                    start: "top 95%",
                    toggleActions: "play none none none",
                    once: true
                }
                }
            );
            }
            if (content) {
            gsap.fromTo(content,
                { opacity: 0, y: 100 },
                {
                opacity: 1,
                y: 0,
                duration: getResponsiveDuration(1),
                delay: 0.5,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: firstArticle,
                    start: "top 60%",
                    toggleActions: "play none none none",
                    once: true
                }
                }
            );
            }

            // Animate from the second article onward, staggered
            for (let i = 1; i < articleItems.length; i++) {
            const article = articleItems[i];
            if (article) {
                gsap.fromTo(article,
                { opacity: 0, y: 100 },
                {
                    opacity: 1,
                    y: 0,
                    duration: getResponsiveDuration(1),
                    delay: 0.5 + i * 0.2, // Stagger delay after the first
                    ease: "power2.out",
                    scrollTrigger: {
                    trigger: article,
                    start: "top 95%",
                    toggleActions: "play none none none",
                    once: true
                    }
                }
                );
            }
            }
        }
        });

    document.querySelectorAll('.product-slider').forEach(function(slider) {
      if (!slider.closest('[data-product-slider-scroll-animation="true"]')) return;
      if (isAnimationDisabled(slider)) return;
      const productItems = slider.querySelectorAll('.product-item');
      productItems.forEach(function(item, i) {
        gsap.fromTo(item,
          { opacity: 0, x: 150 },
          {
            opacity: 1,
            x: 0,
            duration: getResponsiveDuration(1),
            delay: i * 0.1, // stagger each product
            ease: "power2.out",
            scrollTrigger: {
              trigger: slider,
              start: "top 90%",
              toggleActions: "play none none none",
              once: true
            }
          }
        );
      });
    });
  }
  if (window?.gsap && window?.ScrollTrigger) {
    animateWrapperFunction();
  } else {
    // Wait for GSAP and ScrollTrigger to load if they're deferred
    function tryInit() {
      if (window.gsap && window.ScrollTrigger) animateWrapperFunction();
    }
    document.querySelector('script[src*="gsap"]')?.addEventListener('load', tryInit);
    document.querySelector('script[src*="ScrollTrigger"]')?.addEventListener('load', tryInit);
  }
  
});